'use client';

import { usePathname } from 'next/navigation';

export const shouldAlwaysRenderOutbrain = () => {
  const pathname = usePathname();
  const outbrainTestArticle = pathname
    ?.split('/')
    .includes('disney-boycott-subscriptions-marvel-stars-abc-tv-jimmy-kimmel-fcc');

  return outbrainTestArticle;
};
